'use client';

import { useAgentRun } from '@/lib/agent-kit/useAgentRun';
import { resumeImproveStepOrder } from './step-graph';
import type { ResumeImproveResult, ResumeImproveStepKey } from './types';

/**
 * Client hook for the streaming improve endpoint.
 *
 * A thin wrapper over the kit hook that pins the endpoint and the step order, so
 * a call site cannot accidentally render a checklist that does not match the
 * graph the server is actually running.
 *
 * Imports only step-graph, never run.ts — the graph is model-free precisely so
 * the browser bundle does not pull in @ai-sdk/openai and the API key alongside it.
 */
export function useResumeImprove() {
  // The module-level step order is passed by reference on purpose: `useAgentRun`
  // keys `run` and `reset` on the array identity, so a fresh literal here would
  // hand every render new callbacks and break any effect that depends on them.
  return useAgentRun<ResumeImproveStepKey, ResumeImproveResult>(
    '/api/resume-builder/improve',
    resumeImproveStepOrder,
  );
}
